import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import Header from '../../../../components/Header';

export default function Certificate({ onBack }) {
  return (
    <div style={{ marginTop: 20 }}>
      <Header title="Certificate" onBack={onBack} />
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
        <Button variant="contained" style={{ borderRadius: '20px' }}>
          Download Certificate
        </Button>
      </div>
    </div>
  );
}

Certificate.propTypes = {
  onBack: PropTypes.func
};
